import React from 'react';

const CtaSection = () => {
    // Replace these with actual data
    const items = [
        {
            image: require('../../assets/images/product/cat-01.png'),
            title: 'Car Parts',
            devices: 4,
        },
        {
            image: require('../../assets/images/product/cat-02.png'),
            title: 'Applications',
            devices: 4,
        },
        {
            image: require('../../assets/images/product/cat-03.png'),
            title: 'Radiator',
            devices: 4,
        },
        // Add more items as needed
    ];

    return (
        <section className="cta" style={{padding: "5px 0px"}}>
            <div className="auto-container">
                <div className="cta-container">
                    <div className="cta-carousel five-item-carousel owl-carousel owl-theme">
                        {items.map((item, index) => (
                            <div className="cta-content" key={index}>
                                <div className="cta-image">
                                    <img src={item.image} alt={item.title} />
                                </div>
                                <div className="cta-info">
                                    <h5>{item.title}</h5>
                                    <h6>{item.devices} devices</h6>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CtaSection;
